import React from 'react';
import { SkeletonGroup } from '@shared/components/Skeleton/Skeleton';

export type WidgetTransitionProps = Readonly<{
  /**
   * When true, renders `children` with a fade-in animation.
   * When false, renders nothing (blank placeholder).
   */
  isReady: boolean;
  children: React.ReactNode;
}>;

/**
 * Wraps a widget or page section so its content fades in once data resolves.
 * The placeholder is intentionally blank — we show nothing until the real
 * content is ready, then animate it in.
 *
 * See doc/improve-guest-site-perf/15-ssr-narrow-surface/PLAN.md.
 */
export const WidgetTransition: React.FC<WidgetTransitionProps> = ({ isReady, children }) => {
  return (
    <SkeletonGroup
      isReady={isReady}
      placeholder={null}
      width="100%"
    >
      {children}
    </SkeletonGroup>
  );
};

WidgetTransition.displayName = 'WidgetTransition';
